import React, { useState } from "react";
import NutritionTitle from "../Modules/Home/NutritionTitle";


function Home() {

  return (

    <div className="home">
      <NutritionTitle />
    </div>
  );
}

export default Home;
